<template>
  <div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header
        class="border-bottom d-flex flex-row justify-content-between"
      >
        <h6 class="m-0">{{ $t("user.details.title") }}</h6>
        <button
          class="btn btn-info"
          v-if="!editable && !checkIfCanEdit()"
          @click="editAccount"
        >
          {{ $t("user.details.edit.account") }}
        </button>
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form @submit.prevent="updateMyAccount">
                <d-form-row>
                  <d-col md="6" class="form-group">
                    <label for="firstName">{{ $t("user.firstname") }}</label>
                    <d-input
                      :disabled="!editable"
                      type="text"
                      id="firstName"
                      v-model="model.firstName"
                      :state="errors['firstName'] === undefined ? null : false"
                    />
                    <errors :errors="errors" field="firstName" />
                  </d-col>

                  <!-- Last Name -->
                  <d-col md="6" class="form-group">
                    <label for="lastName">{{ $t("user.lastname") }}</label>
                    <d-input
                      :disabled="!editable"
                      type="text"
                      id="lastName"
                      v-model="model.lastName"
                      :state="errors['lastName'] === undefined ? null : false"
                    />
                    <errors :errors="errors" field="lastName" />
                  </d-col>

                  <!-- Email Address -->
                  <d-col md="6" class="form-group">
                    <label for="emailAddress">{{ $t("user.email") }}</label>
                    <d-input-group seamless>
                      <d-input-group-text slot="prepend">
                        <i class="material-icons">&#xE0BE;</i>
                      </d-input-group-text>
                      <d-input
                        :disabled="!editable"
                        id="emailAddress"
                        type="email"
                        v-model="model.email"
                        :state="errors['email'] === undefined ? null : false"
                      />
                    </d-input-group>
                    <errors :errors="errors" field="email" />
                  </d-col>

                  <!-- Phone Number -->
                  <d-col md="6" class="form-group">
                    <label for="phoneNumber">{{ $t("user.phone") }}</label>
                    <d-input-group seamless>
                      <d-input-group-text slot="prepend">
                        <i class="material-icons">&#xE0CD;</i>
                      </d-input-group-text>
                      <d-input
                        :disabled="!editable"
                        id="phoneNumber"
                        v-model="model.phone"
                      />
                    </d-input-group>
                  </d-col>
                </d-form-row>

                <d-form-row>
                  <!-- Adresse -->
                  <d-col md="12" class="form-group">
                    <label for="adresse">{{ $t("user.address") }}</label>
                    <d-textarea
                      :disabled="!editable"
                      id="adresse"
                      name="adresse"
                      rows="3"
                    ></d-textarea>
                  </d-col>
                </d-form-row>
                <d-col md="12" class="text-right">
                  <d-button v-if="editable" type="submit" class="btn-accent">{{
                    $t("global.update")
                  }}</d-button>
                </d-col>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>

    <d-card class="card-small mb-4" v-if="editable">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">{{ $t("user.details.update.password") }}</h6>
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form @submit.prevent="updateMyPassword">
                <d-form-row>
                  <d-col md="6" class="form-group">
                    <label for="password">{{ $t("user.password") }}</label>
                    <d-input
                      type="text"
                      :placeholder="$t('user.password')"
                      id="password"
                      v-model="password"
                      :state="errors['password'] === undefined ? null : false"
                    />
                    <errors :errors="errors" field="password" />
                  </d-col>

                  <d-col md="6" class="form-group">
                    <label for="repeatPassword">{{
                      $t("user.form.confirm.password")
                    }}</label>
                    <d-input
                      type="password"
                      :placeholder="$t('user.password')"
                      id="repeatPassword"
                      v-model="verifyPassword"
                      :state="errors['password'] === undefined ? null : false"
                    />
                  </d-col>
                </d-form-row>
                <d-col md="12" class="text-right">
                  <d-button type="submit" class="btn btn-accent">{{
                    $t("global.update")
                  }}</d-button>
                </d-col>
              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
  </div>
</template>

<script>
import Errors from '../../error/errors.vue';
import ErrorsHelper from '../../../helper/ErrorsHelper';
import { checkIfCanEditUser } from '../../../utils/Rules.js';

export default {
  name: 'user-account-details',
  components: { Errors },
  props: {
    userDetails: {
      type: Object,
    },
    editable: Boolean,
  },
  data() {
    return {
      model: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
      },
      password: '',
      verifyPassword: '',
      errors: {},
      updatableFields: [
        'reference',
        'firstName',
        'lastName',
        'email',
        'phone',
        'address',
      ],
      requiredFields: ['email', 'firstName', 'lastName'],
    };
  },
  mounted() {
    if (this.userDetails.email) {
      this.updatableFields.forEach((field) => {
        this.model[field] = this.userDetails[field];
      });
    }
  },
  methods: {
    editAccount() {
      this.$router.push(`/edit-utilisateur/${this.userDetails.reference}`);
    },
    checkIfCanEdit() {
      return !checkIfCanEditUser(
        this.$store.state.user.informations,
        this.userDetails,
      );
    },
    updateMyAccount() {
      this.errors = {};
      this.model.email = this.model.email.toLowerCase();
      if (
        this.editable &&
        ErrorsHelper.checkErrors(this.requiredFields, this.model, this.errors)
      ) {
        this.$services.user.updateMyAccount(this.model).then((data) => {
          this.$emit('update:userDetails', data.data);
          this.$miniToastr.success(this.$t('user.edit.success'));
        });
      }
    },
    updateMyPassword() {
      this.errors = {};
      if (this.editable && this.password === this.verifyPassword) {
        const body = {
          reference: this.userDetails.reference,
          password: this.password,
        };
        this.$services.user.updateMyPassword(body).then((data) => {
          this.model = data.data;
          this.password = this.verifyPassword = '';
          this.$miniToastr.success(this.$t('user.edit.success'));
        });
      } else {
        ErrorsHelper.addError(
          this.errors,
          'password',
          this.$t('user.form.password.mismatch'),
        );
      }
    },
  },
};
</script>
